import script from "./BountyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BountyView.vue?vue&type=script&lang=ts&setup=true"

import "./BountyView.vue?vue&type=style&index=0&id=4f4e9d78&lang=scss"

const __exports__ = script;

export default __exports__